<div class="page-container">

    <h1>Set Up Your Session</h1>
    <div class="content-container">
        <div class="audit-tool-card more-list-screen-card">
            <form class="audit-tool-cards-container">
                <div class="access-management-form">
                    <div>
                        <h1 class="access-management-headings left-align">Division:</h1>
                        <mat-form-field appearance="outline" color="primary">
                            <mat-label class="" for="division">Division</mat-label>
                            <mat-select color="primary" [(ngModel)]="userOverride['division']"
                                (ngModelChange)="getRolesAndOrgStructure()" name="division" class="custom-control-input" required>
                                <mat-option *ngFor="let division of availableDivisions" [value]="division">
                                    {{division}}
                                </mat-option>
                            </mat-select>
                            <mat-error>Please select a division</mat-error>
                        </mat-form-field>
                    </div>

                    <ng-container *ngIf="userOverride['division']">
                        <h1 class="access-management-headings left-align">Role:</h1>
                        <mat-form-field appearance="outline" color="primary">
                            <mat-label class="" for="role">Role</mat-label>
                            <mat-select color="primary" [disabled]="!availableRoles || availableRoles.length === 0"
                                [ngModel]="currentlySelectedRole" (ngModelChange)="onRoleChange($event)" name="role" class="custom-control-input" required>
                                <mat-option *ngFor="let role of availableRoles" [value]="role">
                                    {{role.name}}
                                </mat-option>
                            </mat-select>
                            <mat-error>Please select a role</mat-error>
                        </mat-form-field>
                    </ng-container>

                    <ng-container *ngIf="userOverride['orgStruct'] && currentlySelectedRole && currentlySelectedRole.levelName !== 'Global'">
                        <h1 class="access-management-headings left-align">Location:</h1>
                        <div class="centered-fields">
                            <app-location-selection
                            [hasInitialState]="false"
                            [userOrgStructure]="userOverride['orgStruct']"
                            [division]="userOverride['division']"
                                [roleLevel]="currentlySelectedRole.levelName"
                                (isValidChanged)="isLocationSelectionValid = $event"
                                (selectedLocation)="selectedLocation = $event"
                                >
                            </app-location-selection>
                        </div>
                    </ng-container>
                </div>

                <button class="csa-button-solid survey-submit" [disabled]="isLoading || !isSelectionValid()" (click)="saveForm()">
                    <fa-icon [icon]="faPlus"></fa-icon>
                    <span> Save Access Settings</span>
                </button>

            </form>
        </div>
    </div>
</div>